import { call, takeLatest, takeEvery, all } from 'redux-saga/effects';

import {
  getComplaints, resolveComplaint,
} from 'api/complaints';
import { COMPLAINTS_ACTION_TYPES } from 'store/actions/complaints.actions';

function* loadComplaintsFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { data } = yield call(getComplaints, payload);
    resolve({ items: data['hydra:member'], total: data['hydra:totalItems'] });
  } catch (e) {
    reject(e.response.data);
  }
}

function* resolveComplaintFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { data: response } = yield call(resolveComplaint, payload);
    resolve(response);
  } catch (e) {
    reject(e.response.data);
  }
}


export default function* () {
  yield all([
    takeLatest(COMPLAINTS_ACTION_TYPES.LOAD_COMPLAINTS, loadComplaintsFlow),
    takeEvery(COMPLAINTS_ACTION_TYPES.RESOLVE_COMPLAINT, resolveComplaintFlow),
  ]);
}
